export interface Category {
  name: string;
  url: string;
  icon: string;
}

export const categories: Category[] = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-honor-of-kings-line' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-pantone-line' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-customer-service-line' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-checkbox-blank-line' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-basketball-line' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-bank-card-line' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-shopping-bag-3-line' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link-m' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

export const MAIN_SITE_URL = 'https://kaspreadsheet.com';
export const BRAND_NAME = 'Vigorbuy Spreadsheet';
export const BRAND_FULL_NAME = 'Vigorbuy Spreadsheet Guide';